import axios from "axios";
import { GenerateEllipse } from "../../types/model/calculation";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/calculations`;

export const downloadEllipseCsv = async (
  captureId: number,
  ellipse: GenerateEllipse,
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post<Blob>(
    `${BASE_URL}/captures/${captureId}/ellipse/csv`,
    ellipse,
    {
      headers: {
        "x-access-token": session?.accessToken,
      },
      responseType: "blob",
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  const blob = new Blob([res.data]);
  const url = globalThis.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `ellipse_${captureId}.csv`;
  link.click();
  link.remove();

  globalThis.URL.revokeObjectURL(url);
};